import angular from 'angular';
import {NavbarTopComponent} from './navbarTop.component.js';

const navbarTop = angular.module('navbartop', []);

navbarTop.component('navbarTop', NavbarTopComponent);

export {navbarTop};



// WEBPACK FOOTER //
// ./app/components/common/navbarTop/navbarTop.js